'use client';
import cn from 'classnames';

import { Button } from '@/components/Button';
import { Link } from '@/components/Link';
import { MockBootcampProps } from '@/mocks/bootcamp';

import s from './InternshipCard.module.scss';

const InternshipCard = ({
  slug,
  isClosed,
  hero,
}: Pick<MockBootcampProps, 'slug' | 'isClosed' | 'hero'>) => {
  return (
    <div>
      <div className={s.imageWrapper}>
        <img
          className={s.image}
          src={hero.image}
          alt={hero.subtitle}
          width={384}
          height={384}
        />

        <div
          className={cn(s.status, {
            [s.close]: isClosed,
          })}
        >
          {hero.statusText}
        </div>
      </div>

      <div className={s.description}>
        <h3 className={s.title}>{hero.title}</h3>

        {isClosed ? (
          <div className={cn(s.button, s.gray)}>Стажировка прошла //</div>
        ) : (
          <Link withButton href={`/bootcamp/${slug}`} className={s.link}>
            <Button
              tagElement="span"
              className={s.button}
              withSlashes
              analyticsOptions={{
                action: `/bootcamp/${slug}`,
                clickZone: 'body',
                clickElement: 'buttonclick',
                clickContent: 'Подробнее',
                uniqueId: `internship-card-button`,
                transitionType: 'inside-link',
                clickZoneCategory: 'site-body',
                transitionTypeMetrics: 'internal',
                transitionUrl: `/career/bootcamp/${slug}`,
              }}
            >
              Подробнее
            </Button>
          </Link>
        )}
      </div>
    </div>
  );
};

export { InternshipCard };
